import { render, staticRenderFns } from "./pagination-2.vue?vue&type=template&id=311088f1"
import script from "./pagination-2.vue?vue&type=script&lang=js"
export * from "./pagination-2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports